import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { HTMLContent } from '../components/Content';
import GMap from '../components/Map';

export const AboutPageTemplate = ({ title, content, address, phone }) => {
  return (
    <div>
      <section className='hero is-primary is-bold'>
        <div className='container'>
          <div className='hero-body'>
            <div className='columns'>
              <div className='column is-12 '>
                <h1 className='title' id='content'>
                  {title}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        style={{
          margin: '0 auto',
          maxWidth: 960,
          padding: '0px 1.0875rem 1.45rem',
          paddingTop: 0,
        }}
      >
        <section className='section section--gradient'>
          <div className='container'>
            <div className='columns'>
              <div className='column is-10 is-offset-1'>
                <div className='section'>
                  <div className='content'>
                    <HTMLContent content={content} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='section section--gradient'>
          <GMap width={'100%'} height={'40vh'} label={'Pacific ESI'} address={address} phone={phone} />
        </section>
      </div>
    </div>
  );
};

AboutPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  address: PropTypes.string,
  phone: PropTypes.string,
};

const AboutPage = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <div>
      <Helmet>
        <title>{post.frontmatter.meta_title}</title>
        <meta name='description' content={post.frontmatter.meta_description} />
        <link rel='icon' type='image/png' href='/img/pesilogo_32x32.png' />
      </Helmet>
      <AboutPageTemplate
        title={post.frontmatter.title}
        address={post.frontmatter.address}
        phone={post.frontmatter.telephone}
        content={post && post.html}
      />
    </div>
  );
};

AboutPage.propTypes = {
  data: PropTypes.object,
};

export default AboutPage;

export const aboutPageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        meta_title
        meta_description
        address
        telephone
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/about-page.js